<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <!--      <div  v-if="show_instructions" class="dummy text-md py-2 mt-8 mb-auto inline-block">&nbsp;</div>-->
    <div class="popup_video_container relative" @click="prevent_close($event)">
      <div class="option-bar" v-if="is_closable" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <vueper-slides
        ref="slider"
        :slide-ratio="getCurrentSectionContent().slide_ratio"
        :fixed-height="false"
        :bullets="false"
        arrows-outside
        fade
        @before-slide="on_before_slide($event)"
      >
        <vueper-slide
          v-for="i in slide_count"
          :key="i"
          :content="slide_src(i)"
        />
      </vueper-slides>
    </div>

    <!--      <div v-if="show_instructions" class="app-popup-instructions text-gray-100 text-sm px-12 py-2 text-md w-18 rounded-full inline-block mb-8 bg-black self-center mt-auto">-->
    <!--        <span>The image will close automatically after a few seconds.</span>-->
    <!--      </div>-->
  </div>
</template>
<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import { mapState, mapGetters } from "vuex";
export default {
  name: "SlideshowPopup",
  components: {
    VueperSlides,
    VueperSlide
  },
  data() {
    return {
      timer: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_secondary_section",
      "current_secondary_sub_section"
    ]),
    ...mapGetters(["sectionContent", "eventTag"]),

    page_url() {
      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/slideshow/";

      return str;
    },
    slide_count() {
      console.log(
        "test",
        this.getCurrentSectionContent,
        this.sectionContent(this.current_section)
      );
      return this.getCurrentSectionContent().count; //this.$store.state.popup_video_src == "1" ? 4 : 5;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    is_video_src() {
      return (
        undefined != typeof this.$store.state.popup_img_src &&
        this.$store.state.popup_img_src != ""
      );
    },
    video_popup_class() {
      return "popup " + this.loading;
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    slide_src(qid) {
      return (
        '<img src="static/content/' +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/" +
        this.getCurrentSectionContent().filename_prefix +
        this.padZeroes(qid) +
        "." +
        this.getCurrentSectionContent().filetype +
        '">'
      );
    },
    padZeroes(num) {
      var str = "0" + (num + "");
      return str.slice(-2);
    },
    click_close_popup(e) {
      if (this.is_closable) {
        e.preventDefault();
        this.close_popup(e);
      }
    },
    close_popup(e) {
      //if(e)
      //e.preventDefault();

      //there's a difference between the number of the transition
      //and what unity's animator is expecting for its param.
      //so unity is always one number ahead
      //quick fix is to send transition number minus one, but let's do better next time
      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_unity_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      }
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },
    onPopupTimeout() {
      if (this.$store.state.app_state === 0) {
        //this.$bus.$emit('send_unity_msg', 'OnContinueTransition', this.$store.state.popup_img_src)
        console.log("requesting closing popup by timeout");
        //this.$bus.$emit('on-transition-started', '6');
        // this.$store.dispatch('set_popup_state', '');
        this.close_popup(null);
      }
    },
    on_before_slide(e) {
      console.log(
        this.$store.state.app_state,
        e.currentSlide.index == this.slide_count - 1,
        e.nextSlide.index == 0
      );
      if (this.$store.state.app_state == 0) {
        if (
          e.currentSlide.index == this.slide_count - 1 &&
          e.nextSlide.index == 0
        ) {
          this.close_popup(e);
        }
      }
    },
    force_slide(idx) {
      console.log(idx, "force slide?");
      console.log(this.$refs.slider);
      this.$refs.slider.goToSlide(idx - 1);
    }
  },
  mounted() {
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$bus.$on("force-slide", this.force_slide);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    this.$bus.$off("on-request-video-close", this.close_popup);
    this.$bus.$off("force-slide", this.force_slide);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  xjustify-content: center;
}
.popup_video_container {
  margin-top: auto;
  margin-bottom: auto;
}

.option-bar {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
  z-index: 1900;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
.popup_video_container {
  align-self: center;
}
.popup_video_container img {
  max-height: 70vh;
}
.vueperslides {
  width: 60vw;
  max-width: 1000px;
  max-height: 80vh;
  color: #f0f0f0;
}
.popup_video_container /deep/ .vueperslides__inner,
.popup_video_container /deep/ .vueperslide__content-wrapper {
  max-height: 80vh;
}
.popup_video_container /deep/ .vueperslide__content {
}
.popup_video_container /deep/ .vueperslide__content img {
  max-height: 80vh;
}
.vueperslides--fixed-height {
  height: 800px;
}
@media only screen and (max-width: 1110px) {
  .popup .option-bar {
    top: -50px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .popup .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>
<style>
@media only screen and (max-width: 1110px) {
  .popup .vueperslides__arrows--outside {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/SlideshowPopup.vue